import React from "react";
import ChatWidget from "../components/ChatWidget";

export function DefaultApp({ Component, pageProps }: any) {
    return (
        <>
            <Component {...pageProps} />
            <ChatWidget />
        </>
    );
}
